<div id="overlay">
  <div class="modal-widget">
    <div class="header">
      <button type="button" class="close" (click)="modalService.showChildModal = false">Close</button>
    </div>
    <div class="title">Not so fast…</div>
    <div class="text">
      By making an update to your designation, the policy benefit will now be evenly distributed among your children.
    </div>
    <div class="footer">
      <button type="button" class="btnSubmit" (click)="modalService.saveChildren = true">Continue</button>
      <button type="button" class="btnCancel" (click)="modalService.showChildModal = false">Cancel</button>
    </div>
  </div>
</div>
